import { Box, Modal, Typography } from "@mui/material";
import "../../CSS/ComponentCSS/PrivacyPolicyModal.css";
import ButtonComponent from "../Inputs/ButtonComponent";

type PrivacyPolicyProps = {
  open: boolean;
  onClose: (value: boolean) => void;
  cancel?: boolean;
  language: number;
};
export default function PrivacyPolicyModal(props: PrivacyPolicyProps) {
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box className="PrivacyPolicyModalBox">
        <Typography variant="h4" style={{ marginBottom: "10px" }}>
          {props.language == 1
            ? "* 개인정보 처리방침"
            : props.language == 2
            ? "* Privacy policy"
            : props.language == 3
            ? "* 個人情報処理方針"
            : props.language == 4
            ? "* 隐私政策"
            : props.language == 5
            ? "* 隱私權政策"
            : ""}
        </Typography>
        {props.language == 1 ? (
          <Typography variant="body1">
            본 개인정보처리방침은 본 방침이 게시된 웹사이트에서 제공되거나
            수집되는 정보의 처리에 대해 설명합니다. 또한, 타사 웹사이트 또는
            플랫폼에 있는 회사의 애플리케이션을 사용함으로써 제공되거나 수집되는
            정보의 처리에 대해 설명합니다. 회사는 이용자의 개인정보를
            중요시하며, 개인정보처리방침을 통해 회사가 이용자로부터 제공받은
            개인정보를 어떠한 용도와 방식으로 이용하고 있으며, 개인정보 보호를
            위해 어떠한 조치를 취하고 있는지 알려드립니다. 본 방침은 2025년 05월
            08일부터 시행되며, 이를 개정하는 경우 웹사이트 공지사항(또는 서면,
            팩스, 이메일 등의 개별공지)을 통해 공지하겠습니다. 수집하는 정보 및
            수집 방법 수집하는 개인정보의 항목 회사가 수집하는 개인정보의 항목은
            다음과 같습니다. 이용자가 제공하는 정보 회사는 이용자가 직접
            제공하는 정보를 수집할 수 있습니다. 인터넷 회원제 서비스의 경우,
            이름, 이메일, 주소, ID, 전화번호, 우편주소, 국가정보, 암호화된
            동일인 식별정보(CI), 중복가입확인정보(DI) 등을 수집합니다.
            미성년자인 경우 법정대리인의 정보(법정대리인의 이름, 생년월일, CI,
            DI 등)도 수집합니다. 온라인 결제 서비스의 경우, 이름, 주소,
            전화번호, 이메일 주소 등과 계좌번호, 카드번호 등의 결제정보, 배송
            주소지, 수령인 이름, 수령인 연락처 등의 배송정보, 입찰 구매 판매
            등의 정보를 수집합니다. 소셜 네트워크 서비스의 경우, 이름, 이메일
            주소, ID, 전화번호, 우편주소, 국가정보, 주소록(지인) 등의 정보를
            수집하며, 사진 촬영 장소, 파일 생성 날짜 등의 정보와 회원이 보거나
            이용하는 콘텐츠의 유형, 회원의 활동 빈도나 기간 등 회원의 서비스
            이용에 관한 정보를 수집합니다. 이용자가 서비스를 사용할 때 수집하는
            정보 회사는 이용자가 직접 제공하는 정보 이외에도 이용자가 회사의
            서비스를 사용하는 과정에서 다음과 같은 정보를 수집할 수 있습니다.
            기기정보: 기기 식별자, 운영 체제, 하드웨어 버전, 기기 설정, 전화번호
            등 로그정보: 로그데이터, 이용시간, 이용자가 입력한 검색어, 인터넷
            프로토콜 주소, 쿠키 및 웹비콘 등 위치정보: GPS, 블루투스 또는
            와이파이 신호를 통한 구체적인 지리적 위치를 포함한 기기 위치에 대한
            정보 등(법으로 허용되는 지역에 한함) 입력정보: 사진촬영 및 기 촬영한
            이미지, 퍼스널컬러 정보, 컬러 선호도, 다양한 설문에 대한 이용자 입력
            정보 등 기타정보: 이용자의 서비스 사용에 있어 선호도, 광고 환경,
            방문하는 페이지 등 수집 방법 회사는 이용자의 정보를 다음과 같은
            방법으로 수집합니다: 웹페이지, 서면양식, 팩스, 전화, 이메일,
            생성정보 수집 툴 등. 협력회사로부터의 제공을 통해서도 정보를
            수집합니다. 수집한 정보의 이용 회사는 수집한 이용자의 정보를 다음과
            같은 목적으로 이용합니다: 회원관리, 본인확인 등 허가받지 않은 서비스
            이용과 부정 이용 등의 탐지 및 방지 이용자가 요구하는 서비스 제공에
            관한 계약 이행 및 요금 정산 등 기존 서비스 개선 및 신규 서비스 개발
            회사 사이트 또는 애플리케이션의 기능 또는 정책 변경사항의 알림 기타
            이용자의 사전 동의에 의한 이용 (예: 마케팅 광고에 활용 등) 연락처에
            등록된 지인 검색•알림•자동 등록, 지인일 가능성이 있는 다른 이용자의
            검색과 알림 회원의 서비스 이용에 대한 통계, 통계학적 특성에 따른
            서비스 제공 및 광고 게재 홍보성 이벤트 정보 제공 및 참여 기회 제공
            준거법 또는 법적 의무의 준수 본 개인정보처리방침에 명시된 목적과
            다른 용도로 정보를 이용할 경우, 회사는 이용자의 동의를 구하도록
            하겠습니다. 수집한 정보의 공유 회사는 다음의 경우를 제외하고
            이용자의 개인정보를 제3자에게 공유하지 않습니다: 회사의 계열사,
            파트너, 서비스 제공업체에 대한 공유: 회사를 대신하여 결제 처리, 주문
            이행, 제품 배송, 분쟁 해결(결제 및 배송 분쟁 포함) 등 서비스를
            회사의 계열사, 파트너, 서비스 제공업체가 수행하는 경우 이용자가
            사전에 동의하는 경우: 이용자의 개인정보를 특정 업체와 공유하여 해당
            업체의 제품 및 서비스에 대한 정보를 제공받기로 이용자가 선택하는
            경우, 이용자의 개인정보를 소셜 네트워킹 사이트와 같은 타사 사이트
            또는 플랫폼과 공유하도록 이용자가 선택하는 경우, 기타 이용자가
            사전에 동의한 경우 법률상 필요한 경우: 법령상 공개하도록 요구되는
            경우, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의
            요구가 있는 경우 쿠키, 비콘 및 기타 유사 기술 회사는 '쿠키(cookies)'
            또는 '웹 비콘(web beacons)' 등을 통하여 비개인적인 집합정보를 수집할
            수 있습니다. 쿠키는 회사의 웹사이트를 운영하는 데 이용되는 서버가
            이용자의 브라우저에 보내는 아주 작은 텍스트 파일로, 이용자의 컴퓨터
            하드디스크에 저장됩니다. 웹 비콘은 웹사이트 또는 이메일 상에 있는
            소량의 코드입니다. 웹 비콘을 사용하여 이용자가 특정 웹이나 이메일
            콘텐츠와 상호 작용했는지 여부를 알 수 있습니다. 이러한 기능은
            서비스를 평가하고 개선하여 이용자 경험을 맞춤 설정하는 데 유용하게
            이용되어 이용자에게 더 향상된 서비스를 제공합니다. 회사가 수집하는
            쿠키의 항목 및 수집 목적은 다음과 같습니다: 반드시 필요한 쿠키: 이
            쿠키는 이용자가 회사의 웹사이트 기능을 이용하는 데 필수적인
            쿠키입니다. 이 쿠키를 허용하지 않으면 장바구니와 전자청구서와 같은
            서비스가 제공될 수 없습니다. 이 쿠키는 마케팅에 사용하거나 사용자가
            인터넷에서 방문한 사이트를 기억하는 데 사용될 수 있는 정보를
            수집하지 않습니다. 웹 브라우저 세션 동안 다른 페이지를 검색할 때
            주문 양식에 입력한 정보를 기억하고, 상품 및 체크아웃 페이지인 경우
            주문한 서비스를 기억하며, 웹사이트에 로그인 여부를 확인합니다. 또한,
            회사가 웹사이트의 작동 방식을 변경할 때 이용자가 회사 웹사이트의
            올바른 서비스에 연결되었는지 확인하고, 서비스의 특정 어플리케이션
            또는 특정 서버로 사용자를 연결합니다. 수행 쿠키: 이 쿠키는 이용자가
            가장 자주 방문하는 페이지 정보와 같이 이용자가 회사 웹사이트를
            어떻게 이용하고 있는지에 대한 정보를 수집합니다. 이 데이터는 회사
            웹사이트를 최적화시키고 이용자가 좀 더 간편하게 웹사이트를 검색할 수
            있도록 도와줍니다. 이 쿠키는 이용자가 누구인지에 대한 정보를
            수집하지 않습니다. 이 쿠키가 수집하는 모든 정보는 종합적으로
            처리되므로 익명성이 보장됩니다. 웹 분석을 통해 웹 사이트를 사용하는
            방법에 대한 통계를 제공하고, 광고 반응 요금을 통해 회사의 광고가
            주는 효과를 확인하며, 제휴사 추적을 통해 회사 방문자 중 하나가
            제휴사의 웹사이트를 방문한 것에 대해 제휴사에게 익명으로 피드백을
            제공합니다. 또한, 오류 관리를 통해 발생하는 오류를 측정하여
            웹사이트를 개선하는 데 도움을 주며, 디자인 테스트를 통해 회사의
            웹사이트의 다른 디자인을 테스트합니다. 기능 쿠키: 이 쿠키는 서비스를
            제공하거나 방문을 개선하기 위해 설정을 기억하는 데 사용됩니다. 이
            쿠키로 수집된 정보는 이용자를 개별적으로 파악하지 않습니다.
            레이아웃, 텍스트 크기, 기본 설정, 색상 등과 같이 적용한 설정을
            기억하고, 회사의 설문 조사에 고객이 응하는 경우 이를 기억합니다.
            대상 쿠키: 이 쿠키는 '좋아요' 버튼 및 '공유' 버튼과 같은 제3자가
            제공하는 서비스와 연결됩니다. 제3자는 용자가 회사의 웹사이트를
            방문한 것을 인지하여 이러한 서비스를 제공합니다. 소셜 네트워크로
            연결하여 해당 소셜 네트워크가 이용자의 방문 정보를 사용하여 나중에
            다른 웹사이트에서 이용자를 대상으로 홍보하며, 이용자가 관심이 있을
            수 있는 광고를 제시할 수 있도록 이용자 방문 정보를 광고 대행사에
            제공합니다. 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다.
            따라서 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나
            쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을
            거부할 수도 있습니다. 단, 이용자가 쿠키 설치를 거부하였을 경우
            회사가 제공하는 일부 서비스에 어려움이 있을 수 있습니다. 이용자의
            접근권한과 선택권 이용자 또는 법정대리인은 정보의 주체로서 회사의
            개인정보 수집, 사용, 공유와 관련하여 다음과 같은 선택권을 행사할 수
            있습니다: 개인정보에 대한 접근권한 개인정보의 정정 또는 삭제
            개인정보 처리의 일시 정지 기존에 제공한 동의의 철회의 요청 이를 위해
            웹페이지의 '회원정보 수정' 메뉴를 이용하거나, 대표전화 또는 회사
            담당부서(또는 개인정보 관리책임자)에게 서면, 전화 또는 이메일로
            연락하시면 지체 없이 조치하겠습니다. 다만, 회사는 법률에 명시된
            타당한 사유 또는 그에 상응하는 사유가 있는 경우에만 그러한 요청을
            거부할 수 있습니다. 보안 회사는 이용자의 개인정보에 대한 보안을 매우
            중요하게 생각합니다. 회사는 이용자 개인정보의 무단 접근, 공개, 사용
            및 수정을 막기 위해 다음과 같은 보안 조치를 구축하고 있습니다:
            개인정보의 암호화 이용자의 개인정보를 암호화된 통신구간을 이용하여
            전송 비밀번호 등 중요정보는 암호화하여 보관 해킹 등에 대비한 대책:
            해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가 유출되거나
            훼손되는 것을 막기 위해 외부로부터 접근이 통제된 구역에 시스템을
            설치 어린이 개인정보 보호 회사는 원칙적으로 13세 미만 또는 관할
            법률상 이에 상응하는 최소 연령의 어린이로부터 정보를 수집하지
            않습니다. 회사의 웹사이트, 제품과 서비스 등은 원칙적으로 일반인을
            대상으로 한 웹사이트입니다. 회사의 웹사이트 또는 애플리케이션에는
            연령 제한 기능이 있어서 어린이가 이용할 수 없도록 하고 있으며,
            그러한 기능을 통해 어린이로부터 고의로 개인정보를 수집하지 않습니다.
            어린이 개인정보를 수집하는 경우, 회사는 부득이 서비스 이용을 위하여
            13세 미만 또는 관할 법률상 이에 상응하는 최소 연령의 어린이의
            개인정보를 수집할 때, 다음과 같은 절차를 추가적으로 거치게 됩니다:
            어린이 개인정보 수집 또는 회사의 제품, 서비스 정보를 어린이에게 직접
            발송하기 위한 보호자 동의 획득 수집한 개인정보 항목, 목적, 공유
            여부를 포함한 회사의 어린이 개인정보보호 방침에 대해 보호자에게 통보
            법정대리인에게 해당 아동의 개인정보에 대한 접근권, 개인정보의 정정
            또는 삭제, 개인정보 처리의 일시 정지, 기존에 제공한 동의의 철회를
            요청할 수 있는 권한 부여 온라인 활동의 참여에 필요한 것 이상의
            개인정보 수집 제한 개인정보처리방침의 변경 회사는 본 방침을 수시로
            수정 또는 변경할 권리를 보유합니다. 회사가 본 방침을 변경하는 경우,
            웹사이트 공지사항(또는 서면, 팩스, 이메일 등의 개별공지)을 통해
            공지하며, 관계법에서 요구하는 경우에는 이용자의 동의를 구하게
            됩니다. 데이터 전송 회사는 전 세계를 무대로 영업하므로 본
            개인정보처리방침에 명시된 목적을 위해 타국에 위치한 회사나 타사에
            이용자의 개인정보를 제공할 수 있습니다. 개인정보가 전송, 보유 또는
            처리되는 곳에 대해서는 회사가 개인정보 보호를 위한 합당한 조치를
            취합니다. 제3자 사이트 및 서비스 회사의 웹사이트, 제품, 서비스 등은
            제3자의 웹사이트, 제품, 서비스 등의 링크를 포함할 수 있습니다.
            링크된 제3자 사이트의 개인정보처리방침이 회사의 정책과 다를 수
            있습니다. 따라서 이용자들은 링크된 제3자 사이트의 개인정보처리방침을
            추가적으로 검토하셔야 합니다. 캘리포니아 거주자에 대한 안내
            캘리포니아에 거주하시는 분이라면 특정 권리사항이 추가될 수 있습니다.
            회사는 캘리포니아 온라인 프라이버시 보호법을 준수하기 위해 회원의
            개인정보를 보호하기 위해 필요한 예방책을 마련합니다. 이용자는
            개인정보가 누출되었을 경우, 정보유출 확인을 요청할 수 있습니다.
            또한, 회사 웹사이트의 모든 이용자는 개인 계정에 접속하여 정보 수정
            메뉴를 이용하여 언제든지 정보를 변경할 수 있습니다. 또한, 회사는
            웹사이트 방문자를 추적하지 않으며, '추적 방지' 신호도 사용하지
            않습니다. 회사는 이용자의 동의 없이 광고 서비스를 통해 개인 식별
            정보를 수집하고 타사에 제공하지 않습니다. 한국인 거주자에 대한 안내
            회사는 대한민국 정보통신망법 및 개인정보보호법이 요구하는 몇 가지
            추가 공개 사항을 다음과 같이 안내합니다. 회사 담당부서 회사는
            이용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기
            위하여 아래와 같이 관련 부서를 지정하고 있습니다. 본 방침에 대해
            의문 사항이 있거나, 회사가 보유한 이용자의 정보를 업데이트하고자
            하는 경우, 아래 연락처로 회사에 연락하시기 바랍니다. 회사 담당부서:
            오콜로르 컨설팅 프로그램사업부서 주소: 서울시 강남구 강남대로 160길
            26 302호 전화: +82 02 1800-6355 이메일: ask@ocollor.com 최종갱신일:
            2025년 05월 08일 출처: 글로버 서비스를 위한 영문 Privacy Policy 작성
            가이드라인 – 네이버주식회사
          </Typography>
        ) : props.language == 2 ? (
          <Typography variant="body1">
            This privacy policy is provided on the website where this policy is
            posted. Describes how the information collected is processed. Also,
            third-party websites or Provided or collected by using the company's
            applications on the platform Explains how the company processes your
            personal information. We value the personal information we receive
            from users through our privacy policy. For what purpose and in what
            manner personal information is used and how is personal information
            protected? We will inform you of the measures we are taking to
            protect your privacy. This policy is effective as of May 2025. It
            will be implemented from the 8th, and if revised, it will be
            announced on the website (or in writing, We will notify you through
            individual notices (fax, e-mail, etc.). Information collected and
            Collection method Items of personal information collected Items of
            personal information collected by the company The following is the
            information provided by the user. The company directly We may
            collect the information you provide. For Internet membership
            services, Name, email, address, ID, phone number, postal address,
            country information, encrypted We collect personal identification
            information (CI), duplicate registration verification information
            (DI), etc. In case of minors, the legal representative's information
            (legal representative's name, date of birth, CI, DI, etc.) are also
            collected. In the case of online payment services, name, address,
            Payment information such as phone number, email address, account
            number, card number, etc., delivery Delivery information such as
            address, recipient name, recipient contact information, etc., bid
            purchase sale We collect information such as: name, email address,
            etc. for social networking services Information such as address, ID,
            phone number, postal address, country information, and address book
            (acquaintances) We collect and use information such as the location
            where the photo was taken, the date the file was created, etc., and
            the information that members can view or use. The type of content
            used, the frequency or duration of member activity, etc., of the
            member's services We collect information about your use. We collect
            information when you use our services. In addition to the
            information directly provided by users, the information company also
            provides information to users through the company. When you use the
            service, we may collect the following information: Device
            information: device identifier, operating system, hardware version,
            device settings, phone number Back log information: log data, usage
            time, search terms entered by users, Internet Location information
            such as protocol address, cookies and web beacons: GPS, Bluetooth or
            Device location, including specific geographic location via Wi-Fi
            signals. Information, etc. (limited to areas permitted by law) Input
            information: Photographs and previously taken photographs User input
            for images, personal color information, color preferences, and
            various surveys Other information such as information: User's
            preferences in using the service, advertising environment, etc. The
            company collects user information in the following ways, such as the
            pages visited: We collect information through: web pages, written
            forms, fax, phone, email, Information collection tools, etc.
            Information is also provided through provision from partner
            companies. We collect. The company uses the collected information of
            users as follows. Used for the same purpose: unauthorized services
            such as member management and identity verification Detection and
            prevention of misuse and abuse, etc., to provide services requested
            by users Improvement of existing services and development of new
            services, including performance of contracts and settlement of fees
            Notification of changes to features or policies of the company site
            or application, etc. Use of contact information based on prior
            consent of the user (e.g. use in marketing advertisements, etc.)
            Search for registered acquaintances, notifications, and automatic
            registration, and find other users who may be acquaintances. Search
            and notifications Statistics on member service usage, statistical
            characteristics Providing services and advertising, providing
            promotional event information and opportunities to participate
            Compliance with applicable laws or legal obligations and the
            purposes set out in this Privacy Policy If the information is used
            for other purposes, the company will obtain the user's consent. We
            will share the collected information with the company except in the
            following cases: We do not share your personal information with
            third parties: our company's affiliates, Sharing with partners and
            service providers: Processing payments, orders on behalf of the
            company Services such as fulfillment, product delivery, and dispute
            resolution (including payment and delivery disputes) If the User is
            a member of the Company's affiliates, partners, or service
            providers, If you agree in advance: We may share your personal
            information with specific companies. Users choose to receive
            information about the company's products and services. In such
            cases, the user's personal information may be shared with
            third-party sites such as social networking sites. Or, if the user
            chooses to share it with the platform, other users If you have given
            prior consent and if required by law: If required by law to disclose
            In this case, for investigative purposes, the investigative agency
            shall conduct the investigation in accordance with the procedures
            and methods prescribed by law. When requested, cookies, beacons and
            other similar technologies companies use 'cookies' Or collect
            non-personal aggregate information through 'web beacons', etc.
            Cookies may be used by the server that operates the company's
            website. A very small text file that is sent to the user's browser,
            and is stored on the user's computer. stored on your hard disk. Web
            beacons are located on websites or in emails. A small amount of
            code. Web beacons are used to identify users to a specific website
            or email. You can tell whether you have interacted with the content.
            This feature To help us evaluate and improve our services and
            personalize your experience. It is used to provide improved services
            to users. The company collects The types of cookies and their
            collection purposes are as follows: Strictly necessary cookies:
            Cookies are essential for users to use the company's website
            functions. These are cookies. If you do not allow these cookies, you
            will not be able to use services such as shopping carts and
            electronic billing. The service cannot be provided. These cookies
            are used for marketing or to inform users Information that can be
            used to remember the sites you visit on the Internet. We do not
            collect any personal information when you browse other pages during
            a web browser session. Remember the information you enter on the
            order form, and if it is a product or checkout page. We remember the
            services you ordered and check if you are logged in to the website.
            Also, When the Company changes the way its website works, the user
            may Make sure you are connected to the correct service and the
            specific application of the service. or connects the user to a
            specific server. Performance cookies: These cookies are used to
            Information about the most frequently visited pages on your company
            website We collect information about how you use our services. This
            data is used by the company Optimize your website and make it easier
            for users to navigate your website. These cookies help us to know
            who you are. We do not collect any information. All information
            collected by these cookies is aggregated. Your anonymity is
            guaranteed as your information is processed. Your use of the website
            is ensured through web analytics. Provides statistics on how your
            company's advertising is performing and how much your advertising
            response rate is. We verify the effectiveness of the service and
            track affiliates to see if one of your company's visitors is Provide
            anonymous feedback to affiliates about your visit to their website.
            It also measures errors that occur through error management. Helps
            improve the website and test the company's designs. Test different
            designs of the website. Functional cookies: These cookies are used
            to provide services Used to remember your settings to provide or
            improve your visit. Information collected through cookies does not
            personally identify users. Applied settings such as layout, text
            size, preferences, colors, etc. Remember, if a customer responds to
            a survey your company takes, we remember that. Targeting cookies:
            These cookies are used by third parties, such as the 'Like' button
            and the 'Share' button. Connected to the services provided by the
            company. Third parties may use the company's website. We provide
            these services by recognizing your visit to social networks. By
            connecting, the social network can use your visit information to
            later We promote to users on other websites and find out if users
            are interested. We share your visit information with advertising
            agencies so that we can present you with relevant advertisements.
            Users have the option to choose whether to install cookies.
            Therefore, you can allow all cookies by setting options in your web
            browser. Confirm every time a cookie is saved, or block saving of
            all cookies You may refuse, but if the user refuses to install
            cookies There may be difficulties with some of the services provided
            by the company. Users Access Rights and Choices Users or their legal
            representatives are the subjects of information and have the right
            to access and choose the company's information. You may exercise the
            following choices regarding the collection, use, and sharing of your
            personal information: There are: Access to personal information
            Correction or deletion of personal information Temporary suspension
            of personal data processing Request for withdrawal of consent
            previously provided For this purpose Use the 'Edit Member
            Information' menu on the webpage, or call the main phone number or
            company. Contact the department in charge (or the person in charge
            of personal information management) in writing, by phone, or by
            email. If you contact us, we will take action without delay.
            However, the company may take action as specified in the law. Such
            requests shall be made only where there is a justifiable or
            equivalent reason. You can refuse. Security companies take the
            security of your personal information very seriously. We take it
            seriously. The company does not allow unauthorized access,
            disclosure, or use of users’ personal information. We are
            implementing the following security measures to prevent
            modifications: Encryption of personal information The user's
            personal information is encrypted using an encrypted communication
            section. Important information such as transmission passwords are
            encrypted and stored. Measures to prevent hacking, etc.: The user's
            personal information may be leaked due to hacking or computer
            viruses. To prevent damage, the system is located in an area with
            controlled access from outside. The company that installs children's
            personal information protection is, in principle, under the age of
            13 or under the jurisdiction of the company. We do not collect
            information from children under the legal minimum age required to do
            so. The company's website, products, and services are not, in
            principle, open to the general public. The target website is the
            company's website or application. It has an age restriction feature
            that prevents children from using it. We do not knowingly collect
            personal information from children through such features. When
            collecting personal information of children, the company must do so
            in order to use the service. Children under the age of 13 or the
            minimum age equivalent to that required by applicable law. When
            collecting personal information, the following additional procedures
            will be followed: Collecting children's personal information or
            providing information about the company's products and services
            directly to children Obtaining parental consent for sending
            Collected personal information items, purpose, and sharing Notify
            parents of the company's privacy policy for children, including
            whether to The legal representative has the right to access and
            correct the child's personal information. Or, you may request
            deletion, temporary suspension of personal data processing, or
            withdrawal of consent previously provided. Request permission to
            access more than what is necessary to participate in online
            activities. Restrictions on collection of personal information
            Changes to personal information processing policy The company may
            change this policy from time to time. We reserve the right to modify
            or change this policy. If the Company changes this policy, Through
            website notice (or individual notice in writing, fax, email, etc.)
            We notify you and, if required by applicable laws, we will seek your
            consent. Yes. Data transmission companies operate globally, so We
            may provide personal information to companies or third parties
            located in other countries for the purposes stated in the privacy
            policy. We may provide you with your personal information. Personal
            information may be transferred, stored or The company takes
            reasonable measures to protect personal information where it is
            processed. Take. Third party sites and service companies' websites,
            products, services, etc. May contain links to third-party websites,
            products, services, etc. The privacy policy of linked third-party
            sites may differ from the company's policy. Therefore, users should
            read the privacy policy of the linked third-party site. Additional
            review is required. Notice to California residents If you are a
            California resident, you may have additional rights. The Company is
            committed to complying with the California Online Privacy Protection
            Act. We take necessary precautions to protect your personal
            information. Users If your personal information has been leaked, you
            can request confirmation of the information leak. Additionally, all
            users of the company website can access their personal account to
            modify their information. You can change your information at any
            time using the menu. Also, the company We do not track website
            visitors and do not use ‘do not track’ signals. The company does not
            use advertising services to identify individuals without the user's
            consent. We do not collect or provide information to third parties.
            Information for Korean residents The company complies with several
            requirements of the Information and Communications Network Act and
            the Personal Information Protection Act of the Republic of Korea.
            Additional disclosures are provided below: Company Department
            Company Protect users' personal information and handle complaints
            related to personal information For this purpose, the relevant
            departments are designated as follows. Regarding this policy: If you
            have any questions or would like to update the information the
            company holds about you, If so, please contact the company at the
            contact information below. Company Department: Ocollor Consulting
            Program Business Department Address: 160 Gangnam-daero, Gangnam-gu,
            Seoul 26 302 Tel: +82 02 1800-6355 Email: ask@ocollor.com Last
            Updated: Source: English Privacy Policy for Global Services, written
            on May 8, 2025 Guidelines – Naver Corporation
          </Typography>
        ) : props.language == 3 ? (
          <Typography variant="body1">
            本プライバシーポリシーは、本方針が掲載されたウェブサイトで提供されます。
            収集される情報の処理について説明します。また、サードパーティのウェブサイトまたは
            プラットフォーム上の企業のアプリケーションを使用することによって提供または収集される
            情報の処理について説明します。会社は利用者の個人情報を
            重要視し、個人情報処理方針を通じて会社が利用者から提供された
            個人情報をいかなる用途や方法で利用しており、個人情報保護を
            のためにどのような措置を取っているかをお知らせします。本方針は2025年05月
            08日から施行され、これを改正する場合、ウェブサイトのお知らせ（または書面、
            ファックス、メール等の個別お知らせ）を通じてお知らせいたします。
            収集方法収集する個人情報の項目会社が収集する個人情報の項目は
            次のとおりです。 提供する情報を収集できます。
            名前、Eメール、住所、ID、電話番号、郵便番号、国情報、暗号化
            同一の識別情報（CI）、重複加入確認情報（DI）などを収集します。
            未成年者の場合、法定代理人の情報（法定代理人の氏名、生年月日、CI、
            DIなど）も収集します。オンライン決済サービスの場合、氏名、住所、
            電話番号、Eメールアドレスなどと口座番号、カード番号などの決済情報、配送
            住所、受取人名、受取人連絡先などの配送情報、入札購入販売
            などの情報を収集します。ソーシャルネットワークサービスの場合、氏名、メール
            住所、ID、電話番号、郵便住所、国情報、住所録（知人）などの情報を
            収集し、写真撮影場所、ファイル作成日などの情報や会員が見たり、
            利用するコンテンツの種類、会員の活動頻度や期間など会員のサービス
            利用に関する情報を収集します。ユーザーがサービスを使用するときに収集する
            情報会社は、ユーザーが直接提供する情報に加えて、
            サービスの使用中に、次の情報を収集できます。
            デバイス情報：デバイス識別子、オペレーティングシステム、ハードウェアバージョン、デバイス設定、電話番号
            などログ情報：ログデータ、利用時間、利用者が入力した検索語、インターネット
            プロトコルアドレス、クッキー、ウェブビーコンなどの位置情報：GPS、Bluetooth、または
            Wi-Fi信号による特定の地理的位置を含む機器の位置について
            情報など（法律で許可されている地域に限る）入力情報：写真撮影と撮影
            画像、パーソナルカラー情報、カラー好み、さまざまなアンケートのユーザー入力
            情報などその他情報：利用者のサービス使用における好み、広告環境、
            訪問するページなど収集方法 会社は利用者の情報を以下のとおり
            方法で収集します：ウェブページ、書面フォーム、ファックス、電話、電子メール、
            生成情報収集ツールなど。協力会社からの提供を通じて情報を
            収集します。収集した情報の利用会社は、収集した利用者の情報を
            同じ目的で利用します：会員管理、本人確認など許可されていないサービス
            利用及び不正利用等の検出及び防止利用者が要求するサービス提供に
            に関する契約履行及び料金決済等、既存サービスの改善及び新規サービスの開発
            会社のサイトまたはアプリケーションの機能またはポリシー変更の通知その他
            利用者の事前同意による利用（例：マーケティング広告に活用等）連絡先へ
            登録された知人検索・通知・自動登録、知人である可能性がある他の利用者の
            検索と通知会員のサービス利用に関する統計、統計学的特性に基づく
            サービスの提供と広告配信のプロモーションイベント情報の提供と参加の機会の提供
            準拠法または法的義務の遵守
            他の用途で情報を利用する場合、当社は利用者の同意を求める
            します。収集した情報の共有会社は、以下の場合を除き
            利用者の個人情報を第三者に共有しません：会社の関連会社、
            パートナー、サービスプロバイダへの共有：会社に代わって支払い処理、注文
            履行、製品配送、紛争解決（決済及び配送紛争を含む）などのサービスを
            会社の関連会社、パートナー、サービスプロバイダが行う場合、利用者
            事前に同意する場合：利用者の個人情報を特定の会社と共有し、
            会社の製品およびサービスに関する情報を提供することをユーザーが選択する
            場合、利用者の個人情報をソーシャルネットワーキングサイトなどの第三者サイト
            またはプラットフォームと共有するようにユーザーが選択した場合、他のユーザー
            事前に同意した場合 法律上必要な場合: 法令上の開示を要求される
            場合、捜査目的で法令で定められた手続及び方法に従い、捜査機関の
            要求がある場合、クッキー、ビーコン、およびその他の類似技術会社は「クッキー」
            または、「Webビーコン」などを介して非個人的な集合情報を収集する
            することができます。クッキーは、会社のウェブサイトを運営するために使用されるサーバーです。
            ユーザーのブラウザに送信する非常に小さなテキストファイルで、ユーザーのコンピュータ
            ハードディスクに保存されます。
            Webビーコンはウェブサイトまたは電子メールにあります
            少量のコードです。
            Webビーコンを使用して、ユーザーが特定のWebまたは電子メール
            コンテンツとやり取りしたかどうかを確認できます。これらの機能は
            サービスを評価して改善してユーザーエクスペリエンスをカスタマイズするのに役立ちます
            利用され、利用者にさらに向上したサービスを提供します。会社が収集する
            クッキーのアイテムと収集の目的は次のとおりです。
            クッキーは、ユーザーが会社のウェブサイト機能を利用するために不可欠です。
            クッキーです。このクッキーを許可しない場合は、ショッピングカートや電子請求書など
            サービスを提供できません。このクッキーはマーケティングに使用するか、ユーザー
            インターネットで訪問したサイトを記憶するために使用できる情報
            収集しません。 Webブラウザセッション中に別のページを検索するとき
            注文フォームに入力した情報を記憶し、商品およびチェックアウトページの場合
            注文したサービスを覚えており、ウェブサイトにログインしているかどうかを確認してください。また、
            会社がウェブサイトの動作方法を変更すると、ユーザーは会社のウェブサイトの
            正しいサービスに接続されていることを確認し、サービスの特定のアプリケーション
            または、特定のサーバーにユーザーを接続します。実行クッキー：このクッキーはユーザーが
            最も頻繁に訪れるページ情報など、ユーザーが会社のウェブサイトを
            どのように利用しているかについての情報を収集します。このデータは会社
            ウェブサイトを最適化し、ユーザーがより簡単にウェブサイトを検索できます
            助ける。このクッキーは、ユーザーが誰であるかに関する情報です。
            収集しません。このクッキーが収集するすべての情報は総合的に
            処理されるため、匿名性が保証されます。ウェブ分析を通じてウェブサイトを利用する
            方法に関する統計を提供し、広告の応答料金を介して会社の広告
            与える効果を確認し、アフィリエイトトラッキングを通じて会社訪問者の1人
            アフィリエイトのウェブサイトを訪問したことについてアフィリエイトに匿名でフィードバック
            提供します。また、エラー管理で発生したエラーを測定し、
            ウェブサイトを改善するのに役立ち、デザインテストを通じて会社の
            ウェブサイトの他のデザインをテストします。機能クッキー：このクッキーはサービスです
            提供または訪問を改善するために設定を覚えているために使用されます。この
            クッキーで収集された情報は、ユーザーを個別に把握しません。
            レイアウト、テキストサイズ、デフォルト設定、色など、適用した設定
            覚えており、会社のアンケートにお客様が応じた場合これを覚えています。
            対象クッキー：このクッキーは「いいね」ボタンや「共有」ボタンなどの第三者
            提供するサービスにリンクされます第三者は、勇者が会社のウェブサイトを
            訪問したことを認識して、これらのサービスを提供します。
            接続して、そのソーシャルネットワークがユーザーの訪問情報を使用して後で
            他のウェブサイトでユーザーを対象に宣伝し、ユーザーが興味を持っている
            広告を表示できるように、ユーザーの訪問情報を広告代理店に
            提供します。ユーザーはクッキーをインストールするためのオプションを持っています。
            したがって、Webブラウザでオプションを設定することですべてのCookieを許可するか、
            クッキーが保存されるたびに確認を受けるか、またはすべてのクッキーの保存
            拒否することもできます。ただし、利用者がクッキーの設置を拒否した場合
            会社が提供する一部のサービスに問題がある可能性があります。ユーザーの
            アクセス権とオプションの利用者または法定代理人は、情報の主体として会社の
            個人情報の収集、使用、共有に関して、以下の選択肢を行使することができます。
            ：個人情報へのアクセス権個人情報の訂正または削除
            個人情報処理の一時停止 既存に提供した同意の撤回の要請これのため
            ウェブページの「会員情報修正」メニューを利用したり、代表電話または会社
            担当部署（または個人情報管理責任者）に書面、電話またはメールで
            ご連絡いただくと遅滞なく措置いたしますが、会社は法律に明記されています。
            妥当な理由またはそれに対応する理由がある場合にのみ、そのような要求
            拒否できます。セキュリティ会社は、ユーザーの個人情報に対するセキュリティを非常に
            重要だと思います。会社は利用者個人情報の無断アクセス、公開、使用
            そして修正を防ぐために、次のセキュリティ対策を策定しています。
            個人情報の暗号化利用者の個人情報を暗号化された通信区間を利用して
            送信パスワードなどの重要情報は暗号化して保管ハッキングなどに備えた対策：
            ハッキングやコンピュータウイルスなどによって利用者の個人情報が漏洩したり、
            毀損を防ぐために、外部からアクセスが制御されたゾーンにシステムを
            設置子供のプライバシー会社は原則として13歳未満または管轄
            法律上、それに対応する最低年齢の子供から情報を収集しないでください。
            ではありません。会社のウェブサイト、製品、サービスなどは原則として一般人
            対象としたウェブサイトです。会社のウェブサイトまたはアプリケーションに
            年齢制限機能があり、子供が利用できないようにしており、
            そのような機能により、子供から意図的に個人情報を収集することはありません。
            子ども個人情報を収集する場合、会社はやむを得ずサービス利用のために
            13歳未満または管轄の法律上、それに対応する最低年齢の子供の
            個人情報を収集する際には、次の手順を追加で行います。
            子ども個人情報の収集または会社の製品、サービス情報を子どもに直接
            発送するための保護者同意獲得収集した個人情報項目、目的、共有
            かどうかを含む会社の子供の個人情報保護方針について保護者に通知する
            法定代理人に当該児童の個人情報へのアクセス権、個人情報の訂正
            または削除、個人情報処理の一時停止、既存に提供した同意の撤回を
            要求できる認可オンライン活動の参加に必要なもの以上 個人情報収集制限
            個人情報処理方針の変更 会社は本方針を随時
            変更または変更する権利を留保します。会社が見た方針を変更した場合、
            ウェブサイトのお知らせ（または書面、ファックス、電子メールなどの個別通知）を介して
            公知であり、関係法で要求する場合には、利用者の同意を求めて
            になります。データ転送会社は世界を舞台に営業しているため、
            個人情報処理方針に記載されている目的のために、他国にある会社または他社に
            利用者の個人情報を提供できます。個人情報が送信、保有、または
            処理される場所については、会社が個人情報を保護するための合理的な措置
            取る。第三者サイトおよびサービス会社のウェブサイト、製品、サービスなどは
            第三者のウェブサイト、製品、サービスなどのリンクを含めることができます。
            リンクされた第三者サイトのプライバシーポリシーが会社の方針と異なる場合があります
            あります。したがって、ユーザーはリンクされた第三者サイトのプライバシーポリシーを
            さらに検討する必要があります。カリフォルニア居住者のご案内
            カリフォルニアにお住まいの方は、特定の権利が追加されることがあります。
            当社は、カリフォルニア州のオンラインプライバシー保護法を遵守するために会員の
            個人情報を保護するために必要な予防策を用意します。ユーザーは
            個人情報が漏洩した場合、情報漏洩確認を要請することができます。
            また、当社ウェブサイトの全利用者は個人アカウントにアクセスして情報を修正
            メニューを使用していつでも情報を変更できます。さらに、会社は
            ウェブサイトの訪問者を追跡せず、「トラッキング防止」信号も使用しない
            ではありません。当社は、利用者の同意なしに広告サービスを通じて個人を識別する
            情報を収集し、サードパーティに提供しません。韓国人住民へのご案内
            会社は大韓民国情報通信網法および個人情報保護法が要求するいくつかの
            追加の開示を次のように案内します。会社担当部署会社は
            利用者の個人情報を保護し、個人情報に関する苦情を処理する
            ために以下のように関連部署を指定しています。本方針について
            疑問がある場合、または会社が保有する利用者の情報を更新したい
            する場合は、下記の連絡先で当社にご連絡ください。会社担当部署：
            オコロールコンサルティングプログラム事業部署住所：ソウル市江南区江南大路160ギル
            26 302電話：+82 02 1800-6355 Eメール：ask@ocollor.com最終更新日：
            2025年05月08日出典：グローバーサービスのための英語Privacy
            Policyの作成 ガイドライン – ネイバー株式会社
          </Typography>
        ) : props.language == 4 ? (
          <Typography variant="body1">
            本隐私政策在发布本政策的网站上提供。
            描述如何处理收集到的信息。此外，第三方网站或
            通过使用公司平台上的应用程序提供或收集
            解释公司如何处理您的个人信息。
            我们重视通过隐私政策从用户处收到的个人信息。
            个人信息用于什么目的、以何种方式使用以及如何保护个人信息？
            我们将告知您我们为保护您的隐私而采取的措施。本政策自2025年5月起生效。
            自8日起实施，如有修改，将在网站（或书面）公布，
            我们将通过个人通知（传真、电子邮件等）通知您。收集的信息和 收集方法
            收集的个人信息项目 公司收集的个人信息项目
            以下是用户提供的信息。本公司直接
            我们可能会收集您提供的信息。对于互联网会员服务，
            姓名、电子邮件、地址、身份证、电话号码、邮政地址、国家信息，加密
            我们收集个人身份信息（CI）、重复注册验证信息（DI）等。
            如果是未成年人，法定代表人的信息（法定代表人姓名、出生日期、CI、 DI
            等）也会被收集。对于在线支付服务，姓名、地址、
            付款信息，如电话号码、电子邮件地址、账号、卡号等，交付
            配送信息如地址、收件人姓名、收件人联系方式等，竞标购买销售
            我们收集的信息包括：姓名、电子邮件地址等，用于社交网络服务
            地址、身份证、电话号码、邮政地址、国家信息、通讯录（熟人）等信息
            我们收集并使用照片拍摄地点、文件创建日期等信息以及会员可以查看或使用的信息。
            会员服务所使用的内容类型、会员活动频率或时长等
            我们收集有关您使用情况的信息。当您使用我们的服务时，我们会收集信息。
            信息公司除用户直接提供的信息外，还通过公司向用户提供信息。
            当您使用本服务时，我们可能会收集以下信息：
            设备信息：设备标识符、操作系统、硬件版本、设备设置、电话号码
            后台日志信息：日志数据、使用时间、用户输入的搜索词、互联网
            位置信息，例如协议地址、cookies 和网络信标：GPS、蓝牙或
            设备位置，包括通过 Wi-Fi 信号定位的具体地理位置。
            信息等（仅限法律允许的领域）输入信息：照片及之前拍摄的照片
            用户输入图像、个人颜色信息、颜色偏好和各种调查
            其他信息如：用户使用服务的偏好、广告环境等。
            本公司通过以下方式收集用户信息，例如访问过的页面：
            我们通过以下方式收集信息：网页、书面表格、传真、电话、电子邮件、
            信息收集工具等。也通过合作公司提供信息。
            我们收集。公司使用收集到的用户信息如下。
            用于同一目的：会员管理和身份验证等未经授权的服务
            检测并防止误用、滥用等，以提供用户所需的服务
            改善现有服务和开发新服务，包括履行合同和结算费用
            通知公司网站或应用程序等的功能或政策的变更。
            基于用户事先同意的使用联系信息（例如用于营销广告等）
            搜索已注册的熟人、通知和自动注册，并查找可能是熟人的其他用户。
            搜索和通知会员服务使用情况统计、统计特征
            提供服务和广告，提供促销活动信息和参与机会
            遵守适用法律或法律义务以及本隐私政策中规定的目的
            若该信息用于其他用途，本公司将取得用户的同意。
            除以下情况外，我们会与该公司共享收集到的信息：
            我们不会与第三方共享您的个人信息：我们公司的关联公司、
            与合作伙伴和服务提供商共享：代表公司处理付款、订单
            履行、产品交付和争议解决（包括付款和交付争议）等服务
            如果用户是本公司的关联公司、合作伙伴或服务提供商，
            如果您事先同意：我们可能会与特定公司共享您的个人信息。
            用户选择接收有关公司产品和服务的信息。
            在这种情况下，用户的个人信息可能会与社交网站等第三方网站共享。
            或者，如果用户选择与平台共享，其他用户
            如果您事先同意且法律要求：如果法律要求披露
            在这种情况下，调查机关为了调查目的，应当依照法律规定的程序和方法进行调查。
            当被要求时，cookies、信标和其他类似技术公司使用“cookies”
            或者通过‘网络信标’等收集非个人汇总信息。
            运行公司网站的服务器可能会使用 Cookie。
            发送到用户浏览器并存储在用户计算机上的非常小的文本文件。
            存储在您的硬盘上。网络信标位于网站或电子邮件中。
            少量代码。网络信标用于识别特定网站或电子邮件的用户。
            你可以判断你是否与内容进行了互动。此功能
            帮助我们评估和改进我们的服务并个性化您的体验。
            用于向用户提供更好的服务。公司收集 Cookie 的类型及其收集目的如下：
            严格必要的 Cookie： Cookies对于用户使用本公司网站功能至关重要。
            这些是 Cookie。如果您不允许这些
            Cookie，您将无法使用购物车和电子账单等服务。 无法提供服务。这些
            Cookie 用于营销或通知用户 可用于记住您在互联网上访问过的网站的信息。
            当您在网络浏览器会话期间浏览其他页面时，我们不会收集任何个人信息。
            记住您在订单上输入的信息，以及它是产品页面还是结帐页面。
            我们会记住您订购的服务，并检查您是否已登录网站。此外，
            当公司改变其网站的工作方式时，用户可能
            确保您连接到正确的服务以及该服务的特定应用程序。
            或将用户连接到特定服务器。性能 Cookie：这些 Cookie 用于
            有关您公司网站上最常访问的页面的信息
            我们收集您如何使用我们服务的信息。这些数据将由公司使用
            优化您的网站并使用户更轻松地浏览您的网站。 这些 cookie
            帮助我们了解您是谁。 我们不收集任何信息。这些 Cookie
            收集的所有信息都是汇总的。
            在处理您的信息时，我们将保证您的匿名性。网站分析将确保您对网站的使用。
            提供有关贵公司广告效果如何以及广告响应率的统计数据。
            我们验证服务的有效性并跟踪关联公司，以查看贵公司的访客是否
            向关联公司提供有关您访问其网站的匿名反馈。
            它还通过错误管理来衡量发生的错误。 帮助改进网站并测试公司的设计。
            测试网站的不同设计。功能性 Cookie：这些 Cookie 用于提供服务
            用于记住您的设置以提供或改善您的访问。 通过 cookie
            收集的信息不会识别用户个人身份。
            应用设置，如布局、文本大小、首选项、颜色等。
            请记住，如果客户对贵公司进行的调查做出回应，我们会记住这一点。 定位
            cookie：这些 cookie 由第三方使用，例如“喜欢”按钮和“分享”按钮。
            连接至本公司提供的服务。第三方可使用本公司的网站。
            我们通过识别您对社交网络的访问来提供这些服务。
            通过连接，社交网络可以使用您的访问信息来
            我们在其他网站上向用户推广并了解用户是否感兴趣。
            我们与广告代理商分享您的访问信息，以便我们向您展示相关的广告。
            用户可以选择是否安装cookies。 因此，您可以通过在 Web
            浏览器中设置选项来允许所有 cookie。 每次保存 cookie
            时都进行确认，或者阻止保存所有 cookie 你可以拒绝，但如果用户拒绝安装
            cookies 本公司提供的部分服务可能会存在困难。用户
            访问权利与选择权用户或其法定代表人是信息主体，有权访问和选择本公司的信息。
            您可以针对您的个人信息的收集、使用和共享做出以下选择：
            有：访问个人信息、更正或删除个人信息 暂停处理个人数据
            请求撤回先前提供的同意 为此目的
            使用网页上的“编辑会员信息”菜单，或致电主要电话号码或公司。
            以书面、电话、电子邮件等方式联系负责部门（或个人信息管理负责人）。
            如果您联系我们，我们将立即采取行动。但公司可能会根据法律规定采取行动。
            只有在有正当理由或同等理由的情况下才可提出此类请求。
            你可以拒绝。安保公司非常重视你的个人信息安全。
            我们对此非常重视。公司不允许未经授权访问、披露或使用用户的个人信息。
            我们正在实施以下安全措施来防止修改： 个人信息的加密
            使用加密通信部分对用户的个人信息进行加密。
            传输密码等重要信息加密保存。防止黑客攻击等措施：
            用户的个人信息可能由于黑客攻击、计算机病毒等原因而泄露。
            为了防止损坏，系统位于可从外部控制访问的区域。
            安装儿童个人信息保护的公司原则上是未满13周岁或受该公司管辖的儿童。
            我们不会收集未达到法定最低年龄的儿童的信息。
            本公司的网站、产品和服务原则上不向公众开放。
            目标网站是公司的网站或应用程序。
            它具有年龄限制功能，可防止儿童使用它。
            我们不会故意通过此类功能收集儿童的个人信息。
            收集儿童的个人信息是公司为了使用服务而必须做的。 年龄未满 13
            岁或符合适用法律规定的最低年龄的儿童。
            在收集个人信息时，将遵循以下附加程序：
            收集儿童个人信息或直接向儿童提供公司产品和服务信息
            获得家长同意发送收集的个人信息项目、目的和共享
            通知家长公司针对儿童的隐私政策，包括是否
            法定代表人有权查阅和更正孩子的个人信息。
            或者，您可以要求删除、暂停处理个人数据，或撤回之前提供的同意。
            请求访问超出参与在线活动所需的权限。 个人信息收集的限制
            个人信息处理政策的变更 本公司可能随时变更本政策。
            我们保留修改或变更本政策的权利。如果公司更改本政策，
            通过网站通知（或以书面、传真、电子邮件等方式单独通知）
            我们会通知您，并且如果适用法律要求，我们将征求您的同意。
            是的。数据传输公司在全球运营，所以
            我们可能会将个人信息提供给位于其他国家的公司或第三方，以实现隐私政策中规定的目的。
            我们可能会向您提供您的个人信息。个人信息可能会被转移、存储或
            公司采取合理措施保护处理个人信息的地方。
            采取。第三方网站和服务公司的网站、产品、服务等。
            可能包含第三方网站、产品、服务等的链接。
            链接的第三方网站的隐私政策可能与公司的政策不同。
            因此，用户应该阅读链接的第三方网站的隐私政策。
            需要进一步审核。加州居民须知
            如果您是加利福尼亚州居民，您可能拥有额外的权利。
            本公司致力于遵守加州在线隐私保护法。
            我们采取必要的预防措施来保护您的个人信息。用户
            如果您的个人信息被泄露，您可以要求确认信息泄露情况。
            此外，公司网站的所有用户都可以访问他们的个人帐户来修改他们的信息。
            您可以随时使用菜单更改您的信息。此外，公司
            我们不跟踪网站访问者，也不使用“不跟踪”信号。
            未经用户同意，公司不会使用广告服务来识别个人。
            我们不会收集或向第三方提供信息。韩国居民须知
            该公司遵守韩国《信息通信网络法》和《个人信息保护法》的多项要求。
            补充披露如下：公司部门公司
            保护用户个人信息并处理与个人信息相关的投诉
            为此，特指定相关部门如下。关于本政策：
            如果您有任何疑问或想更新公司持有的关于您的信息，
            如果需要，请通过以下联系方式联系该公司。公司部门：
            Okolor咨询计划事业部地址：首尔市江南区江南大路160 26 302 电话：+82
            02 1800-6355 邮箱：ask@ocollor.com 最近更新：
            来源：全球服务英文隐私政策，撰写日期：2025 年 5 月 8 日 指南 – Naver
            公司
          </Typography>
        ) : props.language == 5 ? (
          <Typography variant="body1">
            本隱私權政策在發布本政策的網站上提供。
            描述如何處理收集到的資訊。此外，第三方網站或
            透過使用公司平台上的應用程式提供或收集
            解釋公司如何處理您的個人資訊。
            我們重視透過隱私權政策從使用者收到的個人資訊。
            個人資訊用於什麼目的、以何種方式使用、如何保護個人資訊？
            我們將告知您我們為保護您的隱私而採取的措施。本政策自2025年5月起生效。
            自8日起實施，如有修改，將在網站（或書面）公佈，
            我們將透過個人通知（傳真、電子郵件等）通知您。收集的資訊和 收集方法
            收集的個人資訊項目 公司收集的個人資訊項目
            以下是用戶提供的資訊。本公司直接
            我們可能會收集您提供的資訊。對於網路會員服務，
            姓名、電子郵件、地址、身分證、電話號碼、郵寄地址、國家訊息，加密
            我們收集個人識別資訊（CI）、重複註冊驗證資訊（DI）等。
            如果是未成年人，法定代理人的資料（法定代理人姓名、出生日期、CI、 DI
            等）也會被收集。對於線上支付服務，姓名、地址、
            付款訊息，如電話號碼、電子郵件地址、帳號、卡號等，交付
            配送資訊如地址、收件人姓名、收件人聯絡方式等，競標購買銷售
            我們收集的資訊包括：姓名、電子郵件地址等，用於社交網路服務
            地址、身分證、電話號碼、郵寄地址、國家資訊、通訊錄（熟人）等訊息
            我們收集並使用照片拍攝地點、文件創建日期等資訊以及會員可以查看或使用的資訊。
            會員服務所使用的內容類型、會員活動頻率或時長等
            我們收集有關您使用情況的資訊。當您使用我們的服務時，我們會收集資訊。
            資訊公司除用戶直接提供的資訊外，也透過公司提供資訊給用戶。
            當您使用本服務時，我們可能會收集以下資訊：
            設備資訊：設備識別碼、作業系統、硬體版本、設備設定、電話號碼
            後台日誌資訊：日誌資料、使用時間、使用者輸入的搜尋字詞、互聯網
            位置訊息，例如協定位址、cookies 和網路信標：GPS、藍牙或
            設備位置，包括透過 Wi-Fi 訊號定位的具體地理位置。
            資訊等（僅限法律允許的領域）輸入資訊：照片及先前拍攝的照片
            使用者輸入圖像、個人顏色資訊、顏色偏好和各種調查
            其他資訊如：使用者使用服務的偏好、廣告環境等。
            本公司透過以下方式收集使用者訊息，例如造訪過的頁面：
            我們透過以下方式收集資訊：網頁、書面表格、傳真、電話、電子郵件、
            資訊收集工具等。也透過合作公司提供資訊。
            我們收集。本公司使用收集到的使用者資訊如下。
            用於相同目的：會員管理和身分驗證等未經授權的服務
            偵測並防止誤用、濫用等，以提供使用者所需的服務
            改善現有服務和開發新服務，包括履行合約和結算費用
            通知公司網站或應用程式等的功能或政策的變更。
            基於使用者事先同意的使用聯絡資訊（例如用於行銷廣告等）
            搜尋已註冊的熟人、通知和自動註冊，並尋找可能是熟人的其他用戶。
            搜尋並通知會員服務使用統計、統計特徵
            提供服務和廣告，提供促銷活動資訊和參與機會
            遵守適用法律或法律義務以及本隱私權政策中規定的目的
            若該資訊用於其他用途，本公司將取得用戶的同意。
            除以下情況外，我們會與該公司分享收集到的資訊：
            我們不會與第三方分享您的個人資訊：我們公司的關聯公司、
            與合作夥伴和服務提供者分享：代表公司處理付款、訂單
            履行、產品交付和爭議解決（包括付款和交付爭議）等服務
            如果使用者是本公司的關聯公司、合作夥伴或服務供應商，
            如果您事先同意：我們可能會與特定公司分享您的個人資訊。
            使用者選擇接收有關公司產品和服務的資訊。
            在這種情況下，使用者的個人資訊可能會與社交網站等第三方網站共用。
            或者，如果用戶選擇與平台共享，其他用戶
            如果您事先同意且法律要求：如果法律要求披露
            在這種情況下，調查機關為了調查目的，應依照法律規定的程序和方法進行調查。
            當被要求時，cookies、信標和其他類似技術公司使用“cookies”
            或透過『網路信標』等收集非個人匯總資訊。
            運行公司網站的伺服器可能會使用 Cookie。
            發送到使用者瀏覽器並儲存在使用者電腦上的非常小的文字檔案。
            儲存在您的硬碟上。網路信標位於網站或電子郵件中。
            少量代碼。網路信標用於識別特定網站或電子郵件的使用者。
            你可以判斷你是否與內容互動了。此功能
            幫助我們評估和改進我們的服務並個性化您的體驗。
            用於向用戶提供更好的服務。公司收集 Cookie 的類型及其收集目的如下：
            嚴格必要的 Cookie： Cookies對於使用者使用本公司網站功能至關重要。
            這些是 Cookie。如果您不允許這些
            Cookie，您將無法使用購物車和電子帳單等服務。 無法提供服務。這些
            Cookie 用於行銷或通知用戶 可用於記住您在網路上造訪過的網站的資訊。
            當您在網頁瀏覽器會話期間瀏覽其他頁面時，我們不會收集任何個人資訊。
            記住您在訂單上輸入的信息，以及它是產品頁面還是結帳頁面。
            我們會記住您訂購的服務，並檢查您是否已登入網站。此外，
            當公司改變其網站的工作方式時，用戶可能
            確保您連接到正確的服務以及該服務的特定應用程式。
            或將使用者連接到特定伺服器。效能 Cookie：這些 Cookie 用於
            有關您公司網站上最常訪問的頁面的信息
            我們收集您如何使用我們服務的資訊。這些數據將由公司使用
            優化您的網站並使用戶更輕鬆地瀏覽您的網站。 這些 cookie
            幫助我們了解您是誰。 我們不收集任何資訊。這些 Cookie
            收集的所有資訊都是匯總的。
            在處理您的資訊時，我們將保證您的匿名性。網站分析將確保您對網站的使用。
            提供貴公司廣告效果如何以及廣告回應率的統計資料。
            我們驗證服務的有效性並追蹤關聯公司，以查看貴公司的訪客是否
            向關聯公司提供有關您造訪其網站的匿名回饋。
            它也透過錯誤管理來衡量發生的錯誤。 幫助改進網站並測試公司的設計。
            測試網站的不同設計。功能性 Cookie：這些 Cookie 用於提供服務
            用於記住您的設定以提供或改善您的訪問。 透過 cookie
            收集的資訊不會識別使用者個人身分。
            應用程式設置，如佈局、文字大小、首選項、顏色等。
            請記住，如果客戶對貴公司進行的調查做出回應，我們會記住這一點。 定位
            cookie：這些 cookie 由第三方使用，例如「讚」按鈕和「分享」按鈕。
            連接至本公司提供的服務。第三方可使用本公司的網站。
            我們透過識別您對社交網路的存取權來提供這些服務。
            透過連接，社交網路可以使用您的存取資訊來
            我們在其他網站上向用戶推廣並了解用戶是否感興趣。
            我們與廣告代理商分享您的存取訊息，以便我們向您顯示相關的廣告。
            使用者可以選擇是否安裝cookies。 因此，您可以透過在 Web
            瀏覽器中設定選項來允許所有 cookie。 每次儲存 cookie
            時都進行確認，或封鎖保存所有 cookie 你可以拒絕，但如果使用者拒絕安裝
            cookies 本公司提供的部分服務可能有困難。使用者
            存取權利與選擇權使用者或其法定代理人為資訊主體，有權存取和選擇本公司的資訊。
            您可以針對您的個人資訊的收集、使用和分享做出以下選擇：
            有：存取個人資訊、更正或刪除個人資訊 暫停處理個人資料
            請求撤回先前提供的同意 為此目的
            使用網頁上的「編輯會員資訊」選單，或致電主要電話號碼或公司。
            以書面、電話、電子郵件等方式聯繫負責部門（或個人資訊管理負責人）。
            如果您聯絡我們，我們將立即採取行動。但公司可能會根據法律規定採取行動。
            只有在有正當理由或同等理由的情況下才可提出此類請求。
            你可以拒絕。安保公司非常重視你的個人資訊安全。
            我們對此非常重視。本公司不允許未經授權存取、揭露或使用使用者的個人資訊。
            我們正在實施以下安全措施來防止修改： 個人資訊的加密
            使用加密通訊部分對使用者的個人資訊進行加密。
            傳輸密碼等重要資訊加密保存。防止駭客攻擊等措施：
            用戶的個人資訊可能由於駭客攻擊、電腦病毒等原因而洩露。
            為了防止損壞，系統位於可從外部控制存取的區域。
            安裝兒童個人資訊保護的公司原則上是未滿13歲或受該公司管轄的兒童。
            我們不會收集未達法定最低年齡的兒童的資訊。
            本公司的網站、產品和服務原則上不對外開放。
            目標網站是公司的網站或應用程式。
            它具有年齡限制功能，可防止兒童使用它。
            我們不會故意透過此類功能收集兒童的個人資訊。
            收集兒童的個人資訊是公司為了使用服務而必須做的。 年齡未滿 13
            歲或符合適用法律規定的最低年齡的兒童。
            在收集個人資訊時，將遵循以下附加程序：
            收集兒童個人資訊或直接向兒童提供公司產品和服務資訊
            獲得家長同意發送收集的個人資訊項目、目的和分享
            通知家長公司針對兒童的隱私權政策，包括是否
            法定代理人有權查閱和更正孩子的個人資料。
            或者，您可以要求刪除、暫停處理個人數據，或撤回先前提供的同意。
            請求存取超出參與線上活動所需的權限。 個人資訊收集的限制
            個人資訊處理政策的變更 本公司可能隨時變更本政策。
            我們保留修改或變更本政策的權利。若公司更改本政策，
            透過網站通知（或以書面、傳真、電子郵件等方式單獨通知）
            我們會通知您，如果適用法律要求，我們將徵求您的同意。
            是的。數據傳輸公司在全球運營，所以
            我們可能會將個人資訊提供給位於其他國家的公司或第三方，以實現隱私權政策中規定的目的。
            我們可能會向您提供您的個人資訊。個人資訊可能會被轉移、儲存或
            本公司採取合理措施保護處理個人資訊的地方。
            採取。第三方網站和服務公司的網站、產品、服務等。
            可能包含第三方網站、產品、服務等的連結。
            連結的第三方網站的隱私權政策可能與本公司的政策不同。
            因此，用戶應該閱讀連結的第三方網站的隱私權政策。
            需要進一步審核。加州居民須知
            如果您是加州居民，您可能擁有額外的權利。
            本公司致力於遵守加州線上隱私權保護法。
            我們採取必要的預防措施來保護您的個人資訊。使用者
            如果您的個人資訊洩露，您可以要求確認資訊外洩情況。
            此外，公司網站的所有使用者都可以存取他們的個人帳戶來修改他們的資訊。
            您可以隨時使用選單更改您的資訊。此外，公司
            我們不追蹤網站訪客，也不使用「不追蹤」訊號。
            未經用戶同意，本公司不會使用廣告服務來識別個人。
            我們不會收集或向第三方提供資訊。韓國居民須知
            該公司遵守韓國《資訊通信網路法》和《個人資訊保護法》的多項要求。
            補充揭露如下：公司部門公司
            保護用戶個人資訊並處理與個人資訊相關的投訴
            為此，特指定相關部門如下。關於本政策：
            如果您有任何疑問或想更新公司持有的關於您的信息，
            如果需要，請透過以下聯絡方式聯絡該公司。公司部門：
            Okolor諮詢計畫事業部地址：首爾市江南區江南大路160 26 302 電話：+82
            02 1800-6355 信箱：ask@ocollor.com 最近更新：
            資料來源：全球服務英文隱私權政策，撰寫日期：2025 年 5 月 8 日 指南 –
            Naver 公司
          </Typography>
        ) : (
          ""
        )}
        <div className="PrivacyPolicyModalBottom">
          <ButtonComponent
            fullWidth
            variant="contained"
            onClick={() => props.onClose(true)}
            className="MemberUpdateButton"
          >
            {props.language == 1
              ? "확인"
              : props.language == 2
              ? "Check"
              : props.language == 3
              ? "確認"
              : props.language == 4
              ? "查看"
              : props.language == 5
              ? "查看"
              : ""}
          </ButtonComponent>
          {props.cancel && (
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => props.onClose(false)}
              className="MemberDeleteButton"
            >
              {props.language == 1
                ? "취소"
                : props.language == 2
                ? "Cancel"
                : props.language == 3
                ? "キャンセル"
                : props.language == 4
                ? "消除"
                : props.language == 5
                ? "消除"
                : ""}
            </ButtonComponent>
          )}
        </div>
      </Box>
    </Modal>
  );
}
